module.exports = __webpack_public_path__ + "img/circled-play.7955c27e.svg";